export default __webpack_public_path__ + "static/media/brokerStepIcon4.b81afa59.webp";